export default {
    id: "a084d492-c76c-41bf-b54f-fd9e06c0d365",
    icon: "mdi-arrow-u-right-top",
    name: "shapeArrow180",
    title: "Shape Arrow 180 deg",
    description: "A block arrow 180 degrees",
}